<script setup lang="ts">
import {
  CollapsibleContent,
  CollapsibleRoot,
  CollapsibleTrigger
} from 'reka-ui'
import { ref, type HTMLAttributes } from 'vue'

const props = defineProps<{
  class?: HTMLAttributes['class']
  classTrigger?: HTMLAttributes['class']
  classContent?: HTMLAttributes['class']
  openOnMount?: boolean
}>()

const isOpen = ref(props.openOnMount ?? false)
</script>

<template>
  <CollapsibleRoot
    v-model:open="isOpen"
    :unmount-on-hide="false"
    :class="cn('flex flex-col', props.class)"
  >
    <CollapsibleTrigger
      v-if="$slots.trigger"
      :class="cn('group', props.classTrigger)"
    >
      <slot name="trigger" :is-open="isOpen"></slot>
    </CollapsibleTrigger>

    <slot></slot>

    <CollapsibleContent
      v-if="$slots.content"
      :class="cn('CollapsibleContent', props.classContent)"
    >
      <slot name="content" :is-open="isOpen"></slot>
    </CollapsibleContent>
  </CollapsibleRoot>
</template>

<style scoped>
.CollapsibleContent {
  overflow: hidden;
}
.CollapsibleContent[data-state='open'] {
  animation: slideDown 300ms ease-out;
}
.CollapsibleContent[data-state='closed'] {
  animation: slideUp 300ms ease-out;
}
</style>
